import { NgModule } from '@angular/core';
import { SharedService } from '@core/services/shared/shared.service';
import { SharedUserDataService } from '@core/services/shared/shared-user-info.service';
import { SharedWithdrawalService } from '@core/services/shared/shared-withdrawal-info.service';
import { SharedInvestmentService } from '@core/services/shared/shared-investment-info.service';
import { SharedCapitalsMarketService } from '@core/services/shared/shared-capitals-market-info.service';

@NgModule({
    providers: [
        SharedService,
        SharedUserDataService,
        SharedWithdrawalService,
        SharedInvestmentService,
        SharedCapitalsMarketService,
    ] 
})
export class SharedSrvceCbModule{}
 
